import * as React from "react";
const SvgFiRrBellRing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bell-ring_svg__a)">
      <path
        fill="#062147"
        d="m20.86 15.331-3.773 6.155a5.24 5.24 0 0 1-3.87 2.477 5.212 5.212 0 0 1-3.628-.918A4.74 4.74 0 0 1 2.9 16.48l-1.315-1.313a5.263 5.263 0 0 1 .955-8.2L8.307 3.4a8.86 8.86 0 0 1 10.327.551l1.66-1.659a1 1 0 1 1 1.413 1.414L20.05 5.364a8.95 8.95 0 0 1 .81 9.967M8.064 21.647l-3.719-3.72a2.72 2.72 0 0 0 .463 3.264 2.83 2.83 0 0 0 3.256.456m9.921-15.6A6.89 6.89 0 0 0 9.37 5.1L3.592 8.666A3.265 3.265 0 0 0 3 13.752l7.29 7.291a3.266 3.266 0 0 0 5.093-.6l3.755-6.125a6.94 6.94 0 0 0-1.152-8.276zM19.266 24a1 1 0 0 1-.592-1.808 8.63 8.63 0 0 0 3.315-5.407 1 1 0 1 1 1.953.43 10.7 10.7 0 0 1-4.088 6.593 1 1 0 0 1-.589.192M1 5.74a1 1 0 0 1-.8-1.595A10.7 10.7 0 0 1 6.913.02a1 1 0 1 1 .4 1.96A8.64 8.64 0 0 0 1.8 5.334a1 1 0 0 1-.8.405"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bell-ring_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBellRing;
